export default "__VITE_ASSET__8c894097__"